// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { BuildingImg, } from "../assets/images";
// import AuthImages from "../components/AuthImages";

// const Login = () => {
//     const [showPassword, setShowPassword] = useState(false);

//     return (
//         <div className="auth-page">
//             <div className="auth-row d-flex w-100">
//               <AuthImages />
//                 <div className="auth-login-box">
//                     <div className="auth-form d-flex flex-column justify-content-center mx-auto">
//                         <div className="auth-form-title">
//                             <div className="icon">
//                                 <img src={BuildingImg} alt="Building" />
//                             </div>
//                             <h2 className="mb-0">Login</h2>
//                         </div>
//                         <form>
//                             <div className="form-group">
//                                 <label>E-mail</label>
//                                 <input type="email" className="form-control" placeholder="Enter your email" />
//                             </div>
//                             <div className="form-group">
//                                 <label>Password</label>
//                                 <div className="password-input">
//                                     <input
//                                         type={showPassword ? "text" : "password"}
//                                         className="form-control"
//                                         placeholder="Enter your password"
//                                     />
//                                     <span
//                                         className="icon-btn cursor-pointer"
//                                         onClick={() => setShowPassword(!showPassword)}
//                                     >
//                                         <i className={showPassword ? "icon-icon-2" : "icon-icon-1"}></i>
//                                     </span>
//                                 </div>
//                             </div>
//                             <div className="remeber-forgot-box d-flex align-items-center justify-content-between">
//                                 <div className="form-check p-0 m-0">
//                                     <label className="form-check-label d-flex align-items-center" htmlFor="rememberMe">
//                                         <input type="checkbox" className="form-check-input" id="rememberMe" />
//                                         <span>Remember me</span>
//                                     </label>
//                                 </div>
//                                 <Link to="/forgot-password" className="forgot-link">Forgot Password?</Link>
//                             </div>
//                             <button type="submit" className="btns">Login</button>
//                         </form>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Login;


import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import { BuildingImg } from "../assets/images";
import AuthImages from "../components/AuthImages";

const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  // ✅ Validation schema using Yup
  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")   // 🔥 min length check
      .required("Password is required"),                  // 🔥 required
  });
  

  // ✅ Formik setup
  const formik = useFormik({
    initialValues: { email: "", password: "" },
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setErrorMsg("");
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}auth/login`, // your backend login endpoint
          values,
          { headers: { "Content-Type": "application/json", "api-key": process.env.REACT_APP_API_KEY } }
        );

        const { status, data } = response;

        if (status === 200 && data?.status === "success") {
          localStorage.setItem("token", data?.data?.token);
          localStorage.setItem("user", JSON.stringify(data?.data));
          navigate("/dashboard");
        } else if (data?.status === "verify") {
          setErrorMsg("Your account is not verified. Please verify your email.");
        } else {
          setErrorMsg(data?.message?.keyword || "Login failed.");
        }
      } catch (error) {
        console.error("Login Error:", error);
        setErrorMsg(
          error.response?.data?.message?.keyword || "Something went wrong."
        );
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <div className="auth-page">
      <div className="auth-row d-flex w-100">
        <AuthImages />
        <div className="auth-login-box">
          <div className="auth-form d-flex flex-column justify-content-center mx-auto">
            <div className="auth-form-title">
              <div className="icon">
                <img src={BuildingImg} alt="Building" />
              </div>
              <h2 className="mb-0">Login</h2>
            </div>
            <form onSubmit={formik.handleSubmit}>
              {/* Email field */}
              <div className="form-group">
                <label>E-mail</label>
                <input
                  type="email"
                  name="email"
                  className={`form-control ${
                    formik.touched.email && formik.errors.email
                      ? "is-invalid"
                      : ""
                  }`}
                  placeholder="Enter your email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email && (
                  <div className="invalid-feedback">{formik.errors.email}</div>
                )}
              </div>

              {/* Password field */}
              <div className="form-group">
                <label>Password</label>
                <div className="password-input">
                    <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        className={`form-control ${
                            formik.touched.password && formik.errors.password ? "is-invalid" : ""
                        }`}
                        placeholder="Enter your password"
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}   // 🔥 important
                    />
                  <span
                    className="icon-btn cursor-pointer"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <i
                      className={showPassword ? "icon-icon-2" : "icon-icon-1"}
                    ></i>
                  </span>
                </div>
                {formik.touched.password && formik.errors.password && (
                    <div className="invalid-feedback d-block">   {/* 🔥 add d-block so always visible */}
                        {formik.errors.password}
                    </div>
                )}
              </div>

              {/* API error */}
              {errorMsg && <p className="text-danger">{errorMsg}</p>}

              <div className="remeber-forgot-box d-flex align-items-center justify-content-between">
                <div className="form-check p-0 m-0">
                  <label
                    className="form-check-label d-flex align-items-center"
                    htmlFor="rememberMe"
                  >
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="rememberMe"
                    />
                    <span>Remember me</span>
                  </label>
                </div>
                <Link to="/forgot-password" className="forgot-link">
                  Forgot Password?
                </Link>
              </div>

              {/* Submit button */}
              <button
                type="submit"
                className="btns"
                disabled={formik.isSubmitting}
              >
                {formik.isSubmitting ? "Logging in..." : "Login"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
